import React, { useState, useEffect } from "react";
import { Typography } from "antd";

const { Text } = Typography;

const Timer = (props) => {
  const [countdown, setCountdown] = useState(0);
  const [stopFlag, setStopFlag] = useState(true);

  useEffect(() => {
    if (props.loading) {
      setCountdown(Math.floor(props?.timeDiff));
      const interval = setInterval(() => {
        setCountdown((prevCountdown) => prevCountdown + 1);
      }, 1000);
      return () => {
        clearInterval(interval);
        setCountdown(0);
        setStopFlag(true);
      };
    }

    // eslint-disable-next-line
  }, [props.loading, props?.timeDiff]);

  const formatTime = (timeInSeconds) => {
    const hours = Math.floor(timeInSeconds / 3600);
    const minutes = Math.floor((timeInSeconds % 3600) / 60);
    const seconds = timeInSeconds % 60;

    if (stopFlag && minutes >= props?.stopIntervel) {
      setStopFlag(false);
      props?.stop();
    }

    return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(
      2,
      "0"
    )}:${String(seconds).padStart(2, "0")}`;
  };

  return (
    <Text
      className={props.className}
      style={{ marginRight: "1rem", fontSize: "16px" }}
      data-testid="timer"
    >
      {formatTime(countdown)}
    </Text>
  );
};

export default Timer;
